import { render, staticRenderFns } from "./ProjectCardTrialsSteps.vue?vue&type=template&id=0b87abb8&scoped=true&"
import script from "./ProjectCardTrialsSteps.vue?vue&type=script&lang=js&"
export * from "./ProjectCardTrialsSteps.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCardTrialsSteps.vue?vue&type=style&index=0&id=0b87abb8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b87abb8",
  null
  
)

export default component.exports